export const ACTION_TYPES = {
  CHANGE_HEADER_PROGRESS: 'ChangeHeaderProgress',
};

type ActionType = {
  type: typeof ACTION_TYPES[keyof typeof ACTION_TYPES];
  payload: {
    progress?: number;
  };
};

const INITIAL_STATE = {
  headerProgressBarProgress: 0,
};

const extraReducer = (state = INITIAL_STATE, action: ActionType) => {
  switch (action.type) {
    case ACTION_TYPES.CHANGE_HEADER_PROGRESS: {
      return {
        ...state,
        headerProgressBarProgress: action.payload.progress,
      };
    }
    default: {
      return state;
    }
  }
};

export default extraReducer;
